// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2su6C","fileBtn":"File_fileBtn__3DzeK","closeBtn":"File_closeBtn__2qiU3","fileSelected":"File_fileSelected__1ny7v","disabled":"File_disabled__3mhr-"};